// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_UzY","cls2":"NewsInteractionBar-cls2_VR0 NewsInteractionBar-cls1_UzY"};